module.exports = __webpack_public_path__ + "img/8943d77.png";